import {Class} from "./Base"

class ObjectRegistry {
    
    private objects:Record<string, [Function, any]> = {};

    put<T>(type: Class<T>, key:string, value:any)  {
        this.objects[key] = [type, value]; 
    }

    get<T>(type: Class<T>, key:string) : any | undefined {
        if (!this.objects[key]) {
            return undefined;
        }
        const [objType, value] = this.objects[key];
        if (type !== objType && !value) {
            return undefined;
        }
        return value;
    }

    has<T>(type: Class<T>, key:string) : boolean {
        if (!this.objects[key]) {
            return false;
        }
        const [objType, value] = this.objects[key];
        return (type === objType && value);
    }

    private static uniqueInstance = new ObjectRegistry();

    static getInstance() {
        return ObjectRegistry.uniqueInstance;
    }
}

interface KeyValueRegistry<V> {
    put(key:string, value:V) : void,
    get(key:string) : V | undefined;
    has(key:string) : boolean;
    computeIfAbsent(key:string, func: (key:string) => V) : V;
}

export { ObjectRegistry, KeyValueRegistry}